import React from "react";
import spritePath from "./standard.sprite.svg";
export type StarLevel = "fullstar" | "halfstar" | "emptystar";
export interface IconProps {
  className?: string;
  level: StarLevel;
}
export default (properties: IconProps) => {
  const {
    level,
    ...rest
  } = properties;
  switch (level) {
    case "fullstar":
      return <svg fill="#ffd03d" aria-hidden="true" className="svg" data-testid="fullstar" {...rest}>
          <use xlinkHref={`${spritePath}#wholestar`} />
        </svg>;
    case "halfstar":
      return <svg aria-hidden="true" className="svg" data-testid="halfstar" {...rest}>
          <use xlinkHref={`${spritePath}#lefthalfstar`} />
          <use xlinkHref={`${spritePath}#righthalfstar`} />
        </svg>;
    default:
      return <svg fill="#97a18f" aria-hidden="true" className="svg" data-testid="emptystar" {...rest}>
          <use xlinkHref={`${spritePath}#wholestar`} />
        </svg>;
  }
};